import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import { useSubmitFamilyStatusMutation } from '@twisto/api-graphql'
import { Headline, HeadlineTitle } from '@twisto/components/atoms/headline'
import {
  SelectFieldList,
  submittingFlowFormAtom,
  useSubmittingWrapper,
} from '@twisto/flow-views/components'

import { useFlow } from '../../flow/flow.context'

import * as styles from './family-status-step.styles'

export const FamilyStatusStep = () => {
  const [submitting] = useAtom(submittingFlowFormAtom)
  const { flow, sessionId } = useFlow<'FamilyStatusStep'>()
  const [submitFamilyStatus] = useSubmitFamilyStatusMutation()
  const submittingWrapper = useSubmittingWrapper()

  const { familyType } = flow.currentStep

  const handleSubmitField = (familyType: string) =>
    submittingWrapper(
      submitFamilyStatus({
        variables: {
          auth: {
            sessionId,
          },
          input: {
            familyType,
          },
        },
      })
    )

  return (
    <>
      <Headline align="start" css={styles.headlineSection}>
        <HeadlineTitle>
          <Trans id="flow.familyStatus.title" />
        </HeadlineTitle>
      </Headline>
      <SelectFieldList
        disabled={submitting}
        options={familyType.options}
        value={familyType.value}
        onSelectField={handleSubmitField}
      />
    </>
  )
}
